export default __webpack_public_path__ + "static/media/empty.bc5ef19e.png";